import * as devisConf from '@/configuration/devisConf';

export default function calculTauxRemise(remise, typeRemise, totalAvantRemise) {
  if (!remise
    || remise === undefined
    || !typeRemise
    || typeRemise === undefined
    || !totalAvantRemise
    || totalAvantRemise === undefined) {
    return 0;
  }
  if (typeRemise === devisConf.MONTANT) {
    return (remise * 100 / totalAvantRemise);
  }
  return remise;
}
